/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CalendarioEventItemDto } from '../../models/calendario-event-item-dto';

export interface ApiCalendarioCalendarioEventiListGet$Params {
    /**
     * Data di inizio di caricamento degli eventi
     */
    dateFrom: string;

    /**
     * Data di fine di caricamento degli eventi
     */
    dateTo: string;
}

export function apiCalendarioCalendarioEventiListGet(
    http: HttpClient,
    rootUrl: string,
    params: ApiCalendarioCalendarioEventiListGet$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<Array<CalendarioEventItemDto>>> {
    const rb = new RequestBuilder(rootUrl, apiCalendarioCalendarioEventiListGet.PATH, 'get');
    if (params) {
        rb.query('dateFrom', params.dateFrom, {});
        rb.query('dateTo', params.dateTo, {});
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<Array<CalendarioEventItemDto>>;
        }),
    );
}

apiCalendarioCalendarioEventiListGet.PATH = '/api/calendario/calendario-eventi-list';
